import { Css } from './Css';

export function calculateDropdownMaxHeight({
	itemCount,
	maxDisplayItems = 5, // number of first items on the list we want to display, if they are there
	itemHeight = Css.pxToRem(40),
	partialVisibleHeight = Css.pxToRem(20), // visible portion of the next item
	maxDisplayItemsMobile,
}: {
	itemCount: number;
	maxDisplayItems?: number;
	itemHeight?: string;
	partialVisibleHeight?: string;
	maxDisplayItemsMobile?: number;
}): string {
	const maxItems = maxDisplayItemsMobile || maxDisplayItems;

	const fullItems = Math.min(itemCount, maxItems);

	const additionalHeight = itemCount > maxItems ? partialVisibleHeight : '0';

	return `calc(${itemHeight} * ${fullItems} + ${additionalHeight})`;
}
